import { routes } from './routes';
import { ModuleBase } from '../../shared/modules';

export class AssemblyModule extends ModuleBase {
  constructor() {
    super({ routes });
  }
}
